import classNames from "classnames";
import { FC, useRef } from "react";
import ReactPaginate from "react-paginate";
import Colors from "~/constants/colors";
import Icon from "../Icon";
import styles from "./Pagination.module.scss";

interface PaginationProps {
  currentPage?: number;
  total?: number;
  pageSize?: number;
  onPageChange?: (page: number) => void;
  totalPage?: number;
}

const Pagination: FC<PaginationProps> = ({
  currentPage = 1,
  total = 0,
  pageSize = 10,
  onPageChange,
  totalPage
}) => {
  const pageCount = totalPage ?? Math.ceil(total / pageSize);
  const paginationRef = useRef<any>(null);

  return (
    <div className={styles.pagination_container}>
      {/* <Icon
        name="arrow-left-21"
        color={Colors.GREY_800}
        className="cursor-pointer"
        onClick={() => paginationRef.current?.handlePageChange(0)}
      /> */}
      <ReactPaginate
        ref={paginationRef}
        className={styles.pagination}
        pageCount={pageCount}
        breakLabel="..."
        forcePage={currentPage - 1}
        marginPagesDisplayed={1}
        pageClassName={styles.page}
        activeClassName={styles.page_active}
        previousClassName={classNames(styles.previous_icon, {
          [styles.disabled]: currentPage === 0,
        })}
        nextClassName={styles.next_icon}
        previousLabel={<Icon name="arrow-left-2" color={Colors.GREY_800} />}
        nextLabel={<Icon name="arrow-right-3" color={Colors.GREY_800} />}
        onPageChange={({ selected }) => onPageChange?.(selected + 1)}
        renderOnZeroPageCount={() => null}
      />
      {/* <Icon
        name="arrow-right-2-1"
        color={Colors.GREY_800}
        className="cursor-pointer"
        onClick={() => paginationRef.current?.handlePageChange(pageCount - 1)}
      /> */}
    </div>
  );
};

export default Pagination;
